export { CustomerDataProvider as default, useCustomerData } from "./lib/customer-data-segment";
export { track, identify, page } from "./lib/library";
